'use client';

import {useSyncExternalStore} from 'react';

const ALLOWED_PARAMS = ['page', 'p'];

const subscribe = () => () => {};

export const getClientSnapshot = () => window.location.search;

export const getServerSnapshot = () => '';

export const RobotsMetaOverride = () => {
    const search = useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
    const paramKeys = Array.from(new URLSearchParams(search).keys());
    const isNoindex =
        paramKeys.filter((key) => !ALLOWED_PARAMS.includes(key.toLowerCase())).length > 0;
    return <meta name="robots" content={isNoindex ? 'noindex' : 'index, follow'} />;
};
